module.exports = __webpack_public_path__ + "fonts/line-awesome.452a5b4.woff2";